import WbLogo from '__shared/images/icons/wb-logo.png'
import { classNames } from 'utils/utils'
import { useLocation } from 'react-router-dom'

export default function SlimFooter({ className }) {
    return (
        <footer
            className={classNames(
                'text-sm font-openSans pb-9 px-10 max-w-8xl bg-[#080918]',
                className
            )}
        >
            <h2 id="footer-heading" className="sr-only">
                Footer
            </h2>
            <div className="flex flex-col justify-between py-5 mx-auto text-xs border-t border-[#757575] sm:flex-row gap-y-4 gap-x-6 text-white">
                <div className="flex items-center gap-x-6 ">
                    <div>
                        <img
                            src={WbLogo}
                            alt="Warner Bros shield logo"
                            className="object-contain w-full h-[31px]"
                        />
                    </div>
                    <p className="leading-4.5 text-xs sm:text-sm">
                        TM &amp; &copy; 2023 Warner Bros. Entertainment Inc. All
                        rights reserved.
                    </p>
                </div>
                <div className="flex items-center mx-auto text-xs sm:text-sm sm:mx-0 gap-x-8">
                    <div>
                        <a
                            className="leading-4.5 hover:opacity-75"
                            target="_blank"
                            href="https://policies.warnerbros.com/terms/en-us/html/terms_en-us_1.5.0.html"
                        >
                            Terms of Use
                        </a>
                    </div>
                    <div>
                        <a
                            className="leading-4.5 hover:opacity-75"
                            target="_blank"
                            href="https://www.wbdprivacy.com/policycenter/b2c/"
                        >
                            Privacy Policy
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    )
}
